import { FC, useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {Link, useNavigate, useSearchParams} from "react-router-dom";

import HubInputField from "../../components/inputType";

import { resetpasswordSchema } from "../../validation/resetPassword";
import useFetch from "../../hooks/useFetch";
import { APIEndpoints } from "../../types/apiTypes";
import { ResetPasswordAPISuccessResponseType } from "./types";
import { ToastContext } from "../../context/toastContext";
import { ToastTypes } from "../../types";
import {MainLogo, MannKindLogo} from "../../assets";
import ContactAndSafetyInfo from "../../components/contactAndSafetyInfo";
import {TextAlignProps} from "../../components/contactAndSafetyInfo/types";
import FooterText from "../../components/footerText";



const HubResetPassword: FC = (): JSX.Element => {
  const [resetToken, setResetToken] = useState<string>('');
  const [searchParams] = useSearchParams();

  const { showToast } = useContext(ToastContext);
  const navigate = useNavigate();
  const { control, handleSubmit } = useForm({
    mode: 'all',
    resolver: yupResolver(resetpasswordSchema),
  });





  const { loading, data, error, removeErrorAndData, mutate } = useFetch<ResetPasswordAPISuccessResponseType>(APIEndpoints.USER_RESET_PASSWORD);

  useEffect(() => {
    const obj = new URLSearchParams(searchParams);
    setResetToken(obj.get('reset_password_token') || '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (data) {
      const { message } = data;
      showToast([message], ToastTypes.SUCCESS);
      navigate("/users/sign_in");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const submitPassword = async (values: { password: string, confirmPassword: string }) => {
    if ((error && error.length > 0) || data) removeErrorAndData();
    mutate({ user: { reset_password_token: resetToken, ...values } });
  };

  return (
      <div className="container-fluid login-sec pt-3 pt-lg-5 p-0 overflow-auto flex-fill d-flex flex-column">
          <div className="container flex-fill d-flex flex-column">
              <div className="row flex-fill">
                  <div className="col-xl-8 col-lg-7 col-md-5 col-12 d-lg-block d-md-block d-none"></div>
                  <div className="col-xl-4 col-lg-5 col-md-7 col-12">
                      <form className="login-box bg-white rounded-3 p-4 shadow-lg" onSubmit={handleSubmit(submitPassword)}>
                          <h5 className="mb-0 fw-bold text-primary">Reset Password</h5>
                          <div className="mt-3">
                              <Controller
                                  name="password"
                                  control={control}
                                  defaultValue=''
                                  render={({ field, fieldState: { error } }) => (
                                      <HubInputField
                                          inputId="password"
                                          isRowBased={false}
                                          isRequired={true}
                                          field={field}
                                          error={error}
                                          inputLabel="New Password"
                                          inputType="password"
                                      />
                                  )}
                              />
                              <Controller
                                  name="confirmPassword"
                                  control={control}
                                  defaultValue=''
                                  render={({ field, fieldState: { error } }) => (
                                      <HubInputField
                                          inputId="confirmPassword"
                                          isRowBased={false}
                                          isRequired={true}
                                          field={field}
                                          error={error}
                                          inputLabel="Confirm Password"
                                          inputType="password"
                                      />
                                  )}
                              />

                              <button disabled={loading} className="btn btn-primary" type="submit">
                                  <div className="row align-items-center px-1">
                                      {loading ? (
                                          <div className="spinner-border text-light col-3" role="status">
                                              <span className="sr-only"></span>
                                          </div>
                                      ) : null}
                                      <p className="col-auto mb-0"> Reset Password </p>
                                  </div>
                              </button>
                          </div>
                      </form>
                      <ContactAndSafetyInfo alignText={TextAlignProps.TEXT_CENTER} textColor="black" />
                  </div>
              </div>
              <FooterText footerType="black" />
          </div>
      </div>
  );
};

export default HubResetPassword;
